export const PhaseID = {
  Qualified: 4,
};
